"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = void 0;
const RootReducer_1 = require("./RootReducer");
Object.defineProperty(exports, "rootReducer", { enumerable: true, get: function () { return RootReducer_1.rootReducer; } });
